import React, { useEffect, useState } from "react";
import { Plus, Trash2, Edit2, Check, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function AreasPage() {
  const [areas, setAreas] = useState([]);
  const [newName, setNewName] = useState("");
  const [editing, setEditing] = useState(null);
  const [editVal, setEditVal] = useState("");

  const load = async () => { const { data } = await api.get("/areas"); setAreas(data); };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!newName.trim()) return;
    try { await api.post("/areas", { name: newName }); toast.success("Área creada"); setNewName(""); load(); }
    catch { toast.error("Error"); }
  };
  const update = async (id) => {
    try { await api.put(`/areas/${id}`, { name: editVal }); toast.success("Área actualizada"); setEditing(null); load(); }
    catch { toast.error("Error"); }
  };
  const remove = async (id) => {
    if (!window.confirm("¿Eliminar esta área?")) return;
    try { await api.delete(`/areas/${id}`); toast.success("Área eliminada"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Administración</div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Áreas institucionales</h1>
        <p className="text-sm text-slate-500 mt-1">Organice las áreas y dependencias de la institución.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 flex gap-2">
        <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Nueva área…" className="flex-1 input" data-testid="new-area-input" />
        <button onClick={create} className="bg-crejpp hover:bg-crejpp-dark text-white text-sm font-semibold rounded-md px-4 inline-flex items-center gap-2" data-testid="new-area-btn"><Plus className="w-4 h-4" /> Añadir</button>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg divide-y divide-slate-100">
        {areas.map(a => (
          <div key={a.id} className="p-4 flex items-center gap-3">
            {editing === a.id ? (
              <>
                <input value={editVal} onChange={e => setEditVal(e.target.value)} className="input flex-1" data-testid={`area-edit-input-${a.id}`} />
                <button onClick={() => update(a.id)} className="p-2 text-emerald-600 hover:bg-emerald-50 rounded-md" data-testid={`area-save-${a.id}`}><Check className="w-4 h-4" /></button>
                <button onClick={() => setEditing(null)} className="p-2 text-slate-500 hover:bg-slate-100 rounded-md" data-testid={`area-cancel-${a.id}`}><X className="w-4 h-4" /></button>
              </>
            ) : (
              <>
                <div className="flex-1 font-medium text-slate-900" data-testid={`area-name-${a.id}`}>{a.name}</div>
                <button onClick={() => { setEditing(a.id); setEditVal(a.name); }} className="text-slate-500 hover:text-crejpp p-1.5" data-testid={`area-edit-${a.id}`}><Edit2 className="w-4 h-4" /></button>
                <button onClick={() => remove(a.id)} className="text-slate-500 hover:text-crejpp p-1.5" data-testid={`area-delete-${a.id}`}><Trash2 className="w-4 h-4" /></button>
              </>
            )}
          </div>
        ))}
      </div>
      <style>{`.input { width:100%; padding:0.5rem 0.75rem; border:1px solid #cbd5e1; border-radius:0.375rem; font-size:0.875rem; background:white; } .input:focus { outline:none; border-color:#EE1C25; box-shadow:0 0 0 3px rgba(238,28,37,0.12); }`}</style>
    </div>
  );
}
